import Character from "../characters/Character";
import Inventory from "../inventory/Inventory";
import { soundToPlay } from "../sounds/sound";
import { IItem, Item } from "./Item";
import bones from '../../assets/img/bones.png'
import bonesWebp from '../../assets/img/bones.webp'

export type TWeapon = "dagger" | "sword" | "staff" | null

export const initWeapon: IItem = {
    initType: 'weapon',
    initCount: 1,
    initCost: 0,
    initImages: { webp: '', img: '' },
    initArmorType: null,
    initWeaponType: null,
    initStackable: false,
    initName: 'weapon',
    initRestoreValue: 0,
    initArmorValue: 0,
    initWeaponDamage: 0
}

export class Weapon extends Item {
    weaponType: TWeapon
    protected weaponDamage: number

    constructor(weapon: IItem) {
        super(weapon)
        this.weaponType = weapon.initWeaponType
        this.weaponDamage = this.definitionWeaponDamage()
        this.itemLvl = {
            lvl: 1,
            itemToLvlUpName: 'bones',
            itemToLvlUpAmount: 10,
            itemToLvlUpImg: { webp: bonesWebp, img: bones }
        }
    }

    getWeaponType() {
        return this.weaponType
    }

    getWeaponDamage(): number {
        return this.weaponDamage
    }

    useItem(character: Character, characterInventory: Inventory) {
        if (character.getEquipment().weapon.getWeaponType()) {
            character.getEquipment().weapon.remove(character, characterInventory)
        }
        if (this.getCount() <= 0) return
        character.wearingWeapon(this)
        this.setCount(this.getCount() - 1)
        soundToPlay("weapon")
    }

    remove(character: Character, characterInventory: Inventory) {
        this.setCount(1)
        characterInventory.pushInInventory(this)
        character.removeWeapon()
        soundToPlay("weapon")
    }

    definitionWeaponDamage() {
        switch (this.weaponType) {
            case "dagger":
                return 3
            case "sword":
                return 4
            case "staff":
                return 4
            default:
                return 0
        }
    }

    getClone() {
        return new Weapon({
            initType: this.type,
            initCount: this.count,
            initCost: this.cost,
            initImages: this.images,
            initArmorType: null,
            initWeaponType: this.weaponType,
            initStackable: this.stackable,
            initName: this.name,
            initRestoreValue: this.restoreValue,
            initArmorValue: this.armorValue,
            initWeaponDamage: this.weaponDamage
        })
    }

    setItemLvl() {
        const newLvl = this.itemLvl.lvl + 1
        const newItemToLvlUpAmount = this.itemLvl.itemToLvlUpAmount + 10
        const newWeaponDamage = this.weaponDamage + 1

        this.itemLvl = {
            ...this.itemLvl,
            lvl: newLvl,
            itemToLvlUpAmount: newItemToLvlUpAmount
        }

        this.weaponDamage = newWeaponDamage
    }
}